<template>
  <div class="bg-white box-padding mb-40 shadow-lg">
    <TitleWithIcon :title="title" class="mb-40" />
    <slot />
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  title: string
}>()
</script>
